import { render, staticRenderFns } from "./ApiKeys.vue?vue&type=template&id=5b5ca0c4&scoped=true"
import script from "./ApiKeys.vue?vue&type=script&lang=js"
export * from "./ApiKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ca0c4",
  null
  
)

export default component.exports